import React from "react";
import "./App.css";
import "./blog.css";
import "./admin.css";
import "./splash.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Landing from "./pages/Landing";
import { LegalIndex, LegalDoc } from "./pages/Legal";
import { BlogIndex, BlogPost } from "./pages/Blog";
import { GlossaryIndex, GlossaryEntry } from "./pages/Glossary";
import CategoryPage from "./pages/Category";
import DataDeletion from "./pages/DataDeletion";
import Contact from "./pages/Contact";
import Links from "./pages/Links";
import { AdminLogin, AuthCallback, RequireAdmin } from "./pages/AdminAuth";
import AdminDashboard from "./pages/AdminDashboard";
import Splash from "./components/Splash";
import { usePageView } from "./analytics";

function AppRouter() {
  const location = useLocation(); // read hash from here, not window.location.hash (not reactive)
  usePageView();

  // Process the one-time OAuth session_id before any protected route runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/ingredient" element={<BlogIndex />} />
      <Route path="/ingredient/:slug" element={<BlogPost />} />
      <Route path="/ingredients" element={<GlossaryIndex />} />
      <Route path="/ingredients/category/:slug" element={<CategoryPage />} />
      <Route path="/ingredients/:slug" element={<GlossaryEntry />} />
      <Route path="/data-deletion" element={<DataDeletion />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/links" element={<Links />} />
      <Route path="/legal" element={<LegalIndex />} />
      <Route path="/legal/:slug" element={<LegalDoc />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <AdminDashboard />
          </RequireAdmin>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Splash />
          <AppRouter />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
